import React, { FC, useContext } from "react";
import { DropdownAlignment } from "../../../Utility/Dropdown/Dropdown.interface";
import { calculateDropdownPos } from "../../../Utility/Dropdown/calculateDropdownPos";
import {
  IDropdownContext,
  DropdownContext,
} from "../../../Utility/Dropdown/Dropdown.context";
import TooltipTriangleComponent from "./TooltipTriangleComponent";

const TooltipTriangleContainer: FC<IDropdownContext> = ({
  currentPosition,
  currentAlignment,
  buttonRef,
  listRef,
}) => {
  const dropdownCtx = useContext(DropdownContext);
  const { opened } = dropdownCtx;
  const btnRect = buttonRef?.current?.children[0]?.getBoundingClientRect();
  const listRect = listRef?.current?.children[0]?.getBoundingClientRect();

  if (!btnRect || !listRect || !opened) return null;

  const { newPos } = calculateDropdownPos({
    position: currentPosition,
    alignment: DropdownAlignment.FIT,
    btnRect,
    listSizes: {
      ...listRect,
      width: btnRect.width,
      height: btnRect.height,
    },
    reposition: true,
  });
  return (
    <TooltipTriangleComponent
      pos={newPos}
      currentAlignment={currentAlignment}
      currentPosition={currentPosition}
    />
  );
};

export default TooltipTriangleContainer;
